import { LitElement, PropertyValues, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { styles } from '../styles/shared-styles';

@customElement('sessions-pictogram')
export class SessionsPictogram extends LitElement {
  static styles = [
    styles,
    css`
      :host {
        display: block;
        --size: 12px;

      }

      main {

        --gap: 2px;
        display: flex;
        flex-wrap: wrap;
        gap: var(--gap);
        align-items: flex-start;
        justify-content: left;
        width: 80%;
        max-width: 500px;
        margin: 0 auto 1em;
        padding:0;
      }

      .session {
        width: var(--size);
        height: var(--size);
        border-radius: 2px;
      }

    `
  ];

  @property({ type: Map }) sessions = [];


  connectedCallback() {
    super.connectedCallback();
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
  }

  renderStatus(percentComplete) {

    let color = '--sl-color-neutral-0';

    if (percentComplete >= 103) {
      color = '--sl-color-emerald-600';
    } else if (percentComplete >= 100) {
      color = '--sl-color-emerald-600';
    } else if (percentComplete > 80) {
      color = '--sl-color-emerald-50';
    }else if (isNaN(percentComplete)) {
      // In progress
      color = "--sl-color-neutral-800";
    }

    return color;
  }

  renderSession(session) {
    return html`
      <div
        class="session ${session.isActive ? 'active' : '' }"
        data-id=${session.id}
        style="background-color: var(${this.renderStatus(session.percentComplete)})">
      </div>
    `
  }


  render() {
    return html`
      <main>
        ${map(this.sessions, ([_id, session]) => this.renderSession(session))}
      </main>
    `;
  }
}

